module.exports = __webpack_public_path__ + "static/features-phone-activities-40b495cc6acbd8f03dfdb699df14f8cf.png";